import { getMapNode } from "../../content/stages.js";
import { finishNode } from "../run/finishNode.js";
import type { Command, GameState, RunState } from "../types/index.js";
import { accept, reject } from "./reject.js";

type RestCheck = { ok: true; run: RunState } | { ok: false; state: GameState };

function checkRest(state: GameState): RestCheck {
  if (state.screen !== "rest" || !state.run) {
    return { ok: false, state: reject(state, "休日画面でのみ実行できる") };
  }
  const node = getMapNode(state.run.stageId, state.run.currentNodeId);
  if (node?.kind !== "rest") {
    return { ok: false, state: reject(state, "休日ノードがない") };
  }
  return { ok: true, run: state.run };
}

export function handleTakeRest(state: GameState): GameState {
  const check = checkRest(state);
  if (!check.ok) return check.state;

  const run = finishNode(
    { ...check.run, fatigue: Math.max(0, check.run.fatigue - 3) },
    check.run.currentNodeId,
  );

  return accept({ ...state, screen: "map", run, resolution: null });
}

export function handleRestRemove(
  state: GameState,
  command: Extract<Command, { type: "REST_REMOVE" }>,
): GameState {
  const check = checkRest(state);
  if (!check.ok) return check.state;

  const { deck, discard } = check.run;
  const inDeck = deck.some((c) => c.instanceId === command.instanceId);
  const inDiscard = discard.some((c) => c.instanceId === command.instanceId);
  if (!inDeck && !inDiscard) {
    return reject(state, "保有していないカード");
  }

  const removed = {
    ...check.run,
    deck: deck.filter((c) => c.instanceId !== command.instanceId),
    discard: discard.filter((c) => c.instanceId !== command.instanceId),
  };
  const run = finishNode(removed, check.run.currentNodeId);

  return accept({ ...state, screen: "map", run, resolution: null });
}
